export const SET_POST_TAG_ERROR = 'SET_POST_TAG_ERROR';
export const SET_TAGS_LIST_ERROR = 'SET_TAGS_LIST_ERROR';
export const SET_TAGS_LIST = 'SET_TAGS_LIST';
export const SET_FETCHING_TAGS = 'SET_FETCHING_TAGS';
export const SET_SHOW_TAGS_MODAL = 'SET_SHOW_TAGS_MODAL';
